import React, { Component } from "react";
import BrandFeatures from "./widgets/BrandFeatures";
import StandardFeatures from "./widgets/StandardFeatures";
import OptionPackages from "./widgets/OptionPackages";
import ModelList from "./widgets/ModelList";
import ExplainFeaturesSvg from "./widgets/ExplainFeaturesSvg";
import { connect } from "react-redux";
import DoeBanner from "./widgets/DoeBanner";

class ModelDetails extends Component {
  state = {
    selected_refrigerant: "R-448A",
    mesurement_system: "imperial"
  };

  componentDidUpdate(prevProps) {
    if (prevProps.toggleOn !== this.props.toggleOn || this.props.autosuggest.value !== prevProps.autosuggest.value) {
      if(!this.props.toggleOn){
        this.setState({selected_refrigerant: 'R-448A'})
      }
      else{
        this.setState({ selected_refrigerant: "R-455A" });
      }
    }
  }

  changeRefrigerant = e => {
    this.setState({ selected_refrigerant: e.target.value });
  };
  fetchNomen = nomenclature_name => {
    for (var i = 0; i < this.props.compare.nomenclature.length; i++) {
      if (this.props.compare.nomenclature[i].name === nomenclature_name) {
        return this.props.compare.nomenclature[i];
      }
    }
    return null;
  };
  shouldComponentUpdate(nextProps, nextState) {
    //alert("shouldComponentUpdate");
    /*if (
      nextState.selected_refrigerant !== "R-448A" &&
      nextProps.compare.type === "PRO3"
    ) {
      //alert("New Refrig Set");
      return false;
    }*/
    return true;
  }
  render() {
    // alert(this.state.selected_refrigerant + "," + this.props.compare.type);
    var hold_legacy = ((this.props.compare.legacy.modelno).split(" ("))[0].trim();
    var hold_new  = this.props.compare?.doe.length >0 ? ((this.props.compare.doe[0].modelno).split(" ("))[0].trim() : ((this.props.compare.a2l[0].modelno).split(" ("))[0].trim();
    var hold_type = this.props.compare.type;

// LUC family verbiage for Fan Diameter 30 condition
var nochangelegacy = false;
let nonochangelegacyMsg=false;
if(this.state.selected_refrigerant !== "R-454A" && this.state.selected_refrigerant !== "R-454C" && this.state.selected_refrigerant !== "R-455A"){
       if (this.props.compare.type === "LUC") {
          if (this.props.compare.doe.length > 0) {
          const fanDiameter = parseInt(
            this.props.compare.doe[0].refrigerants[
            this.state.selected_refrigerant
            ]["Electrical Ratings"]["Fan Diameter"]["imperial"].replace(",", "")
          );
          if (fanDiameter === 30) {
            nonochangelegacyMsg = true;
          }
          }   
     }  
     else{
         if (this.props.compare.type === "LUC" && this.props.compare.a2l.length > 0) {
              const fanDiameter = parseInt(
                this.props.compare.a2l[0].refrigerants[
                this.state.selected_refrigerant
                ]["Electrical Ratings"]["Fan Diameter"]["imperial"].replace(",", "")
              );
              if (fanDiameter === 30) {
                nonochangelegacyMsg = true;
              }
              }
          }
    }

    // if (
    //   this.state.selected_refrigerant !== "R-448A" &&
    //   this.props.compare.type === "PRO3"
    // ) {
    //   this.setState({ selected_refrigerant: "R-448A" });
    //   //alert("done");
    //   return <div></div>;
    // }
  
    let refrigerants = this.props.compare?.refrigerents;
    let modelType = "";
    if(this.props.compare?.doe.length > 0 && this.props.compare?.a2l.length > 0){ 
        if(this.props.modelIndex <= this.props.compare?.doe.length - 1){
          modelType = "doe";
        }
        else{
          modelType = "a2l";
        }
    }
    else if(this.props.compare?.doe.length > 0){
      modelType = "doe";
    }
    else if(this.props.compare?.a2l.length > 0){
      modelType = "a2l";
    }

    // Dynamically access 'doe' or 'a2l' based on modelType
    let modelData = this.props.compare[modelType]; 

    let doe_banner = modelData.map((Doe_item, index) => {
      let selectable_ref = refrigerants.map(item => {

        //Handle A2L refrigerants for DOE model
        if(modelType === "doe" && (item === "R-455A" || item === "R-454A" || item === "R-454C")){
          item = this.props.compare?.refrigerents[0];
        }
        if (
          !isNaN(
            Doe_item.refrigerants[item]["Efficiency"]["AWEF"][
              this.state.mesurement_system
            ]
          )
        ) {
          return item;
        }
      });
      var filtered_selectable_ref = selectable_ref.filter(function(el) {
        return el != null;
      });

      let selected_refrigerant = (modelType === "doe" && (this.state.selected_refrigerant === "R-455A" || this.state.selected_refrigerant === "R-454A" || this.state.selected_refrigerant === "R-454C")) ? this.props.compare?.refrigerents[0] : this.props.compare?.refrigerents.includes(this.state.selected_refrigerant) ? this.state.selected_refrigerant : this.props.compare?.refrigerents[0];
      let banner = (
        <div className={"inner_tab_element_" + index}>
          <DoeBanner
            type={this.props.compare.type}
            selectable_ref={filtered_selectable_ref}
            modelno={Doe_item.modelno}
            selected_refrigerant={this.state.selected_refrigerant}
            refrigerant={refrigerants}
            onRefChange={this.changeRefrigerant}
            nochangelegacy={nochangelegacy}
            isLegacy={this.props.compare?.doe && this.props.compare?.doe.length > 0}
            toggleOn={this.props.toggleOn}
            awef={
              Doe_item.refrigerants[selected_refrigerant][
                "Efficiency"
              ]["AWEF"][this.state.mesurement_system]
            }
          />
        </div>
      );
      return banner;
    });
 
    let featuresImages = modelData.map((item, index) => {
          var hold_item;

          //Handle A2L refrigerant selection for DOE model
          if(modelType === "doe" && (this.state.selected_refrigerant === "R-455A" || this.state.selected_refrigerant === "R-454A" || this.state.selected_refrigerant === "R-454C")){
             hold_item = item['refrigerants'][this.props.compare?.refrigerents[0]]['Efficiency']['Application Capacity*'];
          }
          else if(!this.props.compare?.refrigerents.includes(this.state.selected_refrigerant)){
             hold_item = item['refrigerants'][this.props.compare?.refrigerents[0]]['Efficiency']['Application Capacity*'];
          }
          else{
             hold_item = item['refrigerants'][this.state.selected_refrigerant]['Efficiency']['Application Capacity*'];
          }
          var real_BTU = null;
          
          if(hold_item!= undefined){
            real_BTU = hold_item[this.state.mesurement_system]
          }

      return (
        <div
          key={item.modelno + index}
          className={"inner_tab_element_" + index}
        >
          <ExplainFeaturesSvg
            type={this.props.compare.type}
            modelnumber={item.modelno}
            replace_btu={real_BTU}
          />
        </div>
      );
    });
    let brandfeatures = modelData.map((item, index) => {
      var hold_item;

      //Handle A2L refrigerant selection for DOE model
      if(modelType === "doe" && (this.state.selected_refrigerant === "R-455A" || this.state.selected_refrigerant === "R-454A" || this.state.selected_refrigerant === "R-454C")){
        hold_item = item['refrigerants'][this.props.compare?.refrigerents[0]]['Efficiency']['Application Capacity*'];
      }
      else if(!this.props.compare?.refrigerents.includes(this.state.selected_refrigerant)){
        hold_item = item['refrigerants'][this.props.compare?.refrigerents[0]]['Efficiency']['Application Capacity*'];
      }
      else{
         hold_item = item['refrigerants'][this.state.selected_refrigerant]['Efficiency']['Application Capacity*'];
      }
      var real_BTU = null;
      if(hold_item!= undefined){
        real_BTU = hold_item[this.state.mesurement_system]
      }
      return (
        <div
          key={item.modelno + index}
          className={"inner_tab_element_" + index}
        >
          <BrandFeatures
            type={this.props.compare.type}
            modelnumber={item.modelno}
            replace_btu={real_BTU}
          />
        </div>
      );
    });

    if(hold_legacy === hold_new && hold_type ==="LUC"){
      return (
        <div>
          <div className="tab-wrapper-section">
            <ModelList
              setModel={this.props.setModel}
              legacy={this.props.compare.legacy}
              doe={this.props.compare.doe}
              a2l={this.props.compare.a2l}
              legacy_nochange = {true}
              modelNumber={this.props.autosuggest.value}
              toggleOn={this.props.toggleOn}
              handleToggleChange={this.props.handleToggleChange}
            />
            <div className="tab-brand-value">
              {doe_banner}
            </div>
          </div>
        </div>
      );
      
    }else{
        return (
        <div>
          <div className="tab-wrapper-section">
            <ModelList
              setModel={this.props.setModel}
              legacy={this.props.compare.legacy}
              doe={this.props.compare.doe}
              a2l={this.props.compare.a2l}
              legacy_nochange = {false}
              modelNumber={this.props.autosuggest.value}
              toggleOn={this.props.toggleOn}
              handleToggleChange={this.props.handleToggleChange}
            />

            <div className="tab-brand-value">
              {doe_banner}
              {featuresImages}
            </div>
          </div>

          <div className="brandfeatures">
            {brandfeatures}
            <StandardFeatures />
          </div>
          <OptionPackages />
        </div>
      );
    }

    
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps, null)(ModelDetails);
